export default {
  rigidBodyTypeTitle: '剛体タイプ',
  rigidBodyType: {
    notRigidBody: '非剛体',
    notRigidBodyTip: '物理的な性質はなく、単なる画像表示として機能します。',
    staticRigidBody: '静的剛体',
    staticRigidBodyTip: '静止した物体を保持し、他の剛体と衝突します。',
    kinematicRigidBody: '運動学的剛体',
    kinematicRigidBodyTip:
      '力や物体の質量を考慮せず、指定された速度や加速度で運動する物体で、他の剛体と衝突します。',
    dynamicRigidBody: '動力学的剛体',
    dynamicRigidBodyTip:
      '一定の質量があり、外力の影響で運動し、ニュートンの運動方程式に従う物体で、他の剛体と衝突します。',
  },
  edge: {
    title: '剛体の輪郭の精度',
    titleTip:
      '値が大きいほど精度が高くなりますが、性能の消耗も大きくなります。適切で可能な限りに、小さいレベルを選択することをお勧めします。',
    previewBtnText: '現在の剛体の輪郭をプレビュー',
    closePreviewBtnText: 'プレビューを閉じる',
    previewAllBtnText: 'すべての剛体の輪郭をプレビュー',
    previewAllBtnTip:
      'すべての剛体の輪郭をプレビューして、初期状態でボディ間に重なりがないことを確認します。ボディの重複は物理的な相互作用を引き起こし、ゲームプレイ中にエラーが発生する可能性があります。',
  },
}
